const data = {
	properties: [
		{
			id: 'AFP AX023UK',
			index: 0,
			coords: { lat: 51.517708, lng: -0.107643 },
			location: 'Holborn, London, UK',
			description: [
				'Aries Tower, constructed in 2003, represents a unique opportunity to acquire an iconic Grade-A prime City office building (freehold) with an enviable centric position.',
				'The property incorporates c. 144k sq ft (c. 12.9k sqm) of highly specified offices over 9 floors let to 7 high-quality tenants on a NN-leases (in excess of 4.2 years WAULT).',
				'Current passing rent of c. £ 7.35m p.a., equating to c. £55.8 per sq ft (slightly under-rented in the context of current rents achieved recently in the location for similar properties). All leases contain open market rent review with overall GRI expected to increase by c. [10-15]% during the next 3 years.',
				'The property was built in 1999 and is arranged over quay level, ground and nine upper floors, with plant and machinery at basement and roof level. Typical floor plates provide approximately 20k sq ft of broadly rectangular and virtually column-free accommodation arranged around the central core.',
				'The property also provides access to an underground car park with 80 car parking spaces.',
			],
			processes: {
				nda: true,
				summary: true,
				loi: true,
				dd: true,
			},
			sell: {
				afp: 'AX023UK',
				digitalId: 100,
				country: 'UK',
				city: 'London',
				address: 'Aries Tower',
				assetType: 'Office',
				category: 'Core',
				subClass: 'Multi-Tenant',
				status: 'Auction',
				loiDue: '30 March 2020, 17:00 GMT',
				loiDeposit: '£1,000',
				auctionDate: 'COB 30 March 2020',
			},
			tenants: [
				{
					tenant: 'AZ AM Ltd.',
					description: 'Asset management firm',
					link: 'www.az-am.co.uk',
					level: 'GF',
					leaseStart: '23/01/2013',
					leaseEnd: '24/01/2025',
					extensionOption: '1 x 5y',
					wault: 4.92,
					gla: 635,
					parking: 5,
					gri: 254000,
					sc: 20320,
					rent: 36.4,
					wgri: 3.5,
					wgla: 4.9,
				},
				{
					tenant: 'Vacancy',
					description: '',
					link: '',
					level: 'GF',
					leaseStart: '23/01/2013',
					leaseEnd: '24/01/2023',
					extensionOption: '1 x 5y',
					wault: 2.91,
					gla: 803,
					parking: 0,
					gri: 0,
					sc: 0,
					rent: 0,
					wgri: 0.0,
					wgla: 6.2,
				},
				{
					tenant: 'Hudson, Lewis & Co LLP',
					description: 'Law firm',
					link: 'www.hlandco.com',
					level: '1F, 2F',
					leaseStart: '01/09/2017',
					leaseEnd: '01/09/2021',
					extensionOption: 'N/A',
					wault: 1.52,
					gla: 2876,
					parking: 18,
					gri: 1581800,
					sc: 142362,
					rent: 50,
					wgri: 21.5,
					wgla: 22.2,
				},
				{
					tenant: 'Tiknet Inc.',
					description: 'IT/media',
					link: 'www.tiknet.tech',
					level: '3F',
					leaseStart: '10/05/2018',
					leaseEnd: '10/05/2023',
					extensionOption: 'N/A',
					wault: 3.2,
					gla: 1439,
					parking: 9,
					gri: 828749,
					sc: 74587,
					rent: 52.4,
					wgri: 11.3,
					wgla: 11.1,
				},
				{
					tenant: 'Peruos Bank AG',
					description: 'Private bank',
					link: 'www.peruos.com',
					level: '4F to 6F',
					leaseStart: '01/01/2016',
					leaseEnd: '15/06/2026',
					extensionOption: '1 x 5y',
					wault: 6.3,
					gla: 2876,
					parking: 12,
					gri: 1725600,
					sc: 155304,
					rent: 54.5,
					wgri: 23.5,
					wgla: 22.2,
				},
				{
					tenant: 'ZeroDark30 LLC',
					description: 'Asset Management/Hedge Fund',
					link: 'www.zero30.com',
					level: '7F',
					leaseStart: '30/09/2018',
					leaseEnd: '30/09/2022',
					extensionOption: '2 x 2y',
					wault: 2.59,
					gla: 1439,
					parking: 12,
					gri: 1007160,
					sc: 90644,
					rent: 63.6,
					wgri: 13.7,
					wgla: 11.1,
				},
				{
					tenant: 'Hanay Re',
					description: 'Re-insurance',
					link: 'www.hanay.re',
					level: '8F',
					leaseStart: '01/03/2019',
					leaseEnd: '01/03/2029',
					extensionOption: '1 x 5y',
					wault: 9.01,
					gla: 1439,
					parking: 12,
					gri: 1013886,
					sc: 91250,
					rent: 64.1,
					wgri: 13.8,
					wgla: 11.1,
				},
				{
					tenant: 'KLC Ltd.',
					description: 'Accounting',
					link: 'www.klcltd.com',
					level: '9F',
					leaseStart: '15/11/2011',
					leaseEnd: '15/11/2021',
					extensionOption: '1 x 3y',
					wault: 1.72,
					gla: 1439,
					parking: 12,
					gri: 935220,
					sc: 84170,
					rent: 59.1,
					wgri: 12.7,
					wgla: 11.1,
				},
			],
			status: {
				status: 'ACTIVE Auction',
				dateLaunch: '10/05/2020',
				lastBid: '22/05/2020',
				ndas: 45,
				teasers: 93,
				ims: 44,
				siteVisits: 18,
				lois: 6,
				bidHigh: 81000000,
				bidLow: 79000000,
			},
			analysis: {
				details: {
					type: 'Freehold',
					GLA: 12945,
					parking: 80,
					GRI: { eur: 8815699, gbp: 7346415 },
					wault: 4.2,
					vacancy: 6.2,
					valuation: { eur: 203279652 },
					GY: 4.25,
					NLA: { sqft: 143692, sqm: 12945 },
					oeio: 169.5,
				},
				output: {
					unleveredIRR: 4.1,
					leveredIRR: 6.84,
					unleveredCash: 1.21,
					leveredCash: 1.36,
				},
				pricing: {
					purchasePrice: 180000000,
					transationCost: 550000,
				},
				general: {
					type: 'Asset Purchase',
					inflation: 'Flat 1%',
					leakage: 8,
					vacancy: 'Yes',
					leaseRenewal: 100,
					tenantIncentive: 5,
					vacancyCost: 33,
				},
				tax: {
					type: 'Non-Resident Owner',
					depreciation: 'Declining-balance',
					cit: 19,
					nrcgt: 20,
				},
				exit: {
					year: 5,
					gri: 8212137,
					capRate: 4,
					tc: 825000,
				},
				leverage: {
					senior: {
						term: 5,
						ltppPercent: 0.65,
						interestType: 'Fixed',
						interest: 2.25,
						upFrontPercent: 0.005,
						amortisation: 0,
						hedgeCost: '-',
					},
					mezz: {
						term: 5,
						ltppPercent: 0.75,
						interestType: 'Fixed',
						interest: 7,
						upFrontPercent: 0.01,
						amortisation: 2,
						hedgeCost: '-',
					},
				},
			},
		},
		{
			id: 'AFP AZ002UK',
			index: 1,
			coords: { lat: 51.528215, lng: -0.090071 },
			location: 'Hoxton, Hackney, London, UK',
			description: [],
			processes: {
				nda: true,
				summary: true,
				loi: true,
				dd: false,
			},
			sell: {
				afp: 'AZ002UK',
				digitalId: 60,
				country: 'UK',
				city: 'London',
				address: 'Libra Co-Working Office',
				assetType: 'Office',
				category: 'Core+',
				subClass: 'Co-Working',
				status: 'Activate',
				loiDue: '27 March 2020, 17:00 GMT',
				loiDeposit: 'Valid',
				auctionDate: 'COB 30 March 2020',
			},
			tenants: [
				{
					tenant: 'LIBRA Co-Working Ltd.',
					description: 'Shared offices operator',
					link: 'www.LibraLifeWork.co.uk',
					level: 'Entire building',
					leaseStart: '01/01/2018',
					leaseEnd: '01/01/2033',
					extensionOption: '1 x 5y',
					wault: 13.19,
					gla: 7575,
					parking: 24,
					gri: 3749850,
					sc: 300320,
					rent: 44.60,
					wgri: '-',
					wgla: '-',
				},
			],
			status: {
				status: 'Inactive',
				dateLaunch: '',
				lastBid: '',
				ndas: '',
				teasers: '',
				ims: '',
				siteVisits: '',
				dataroom: '',
				lois: '',
				bidHigh: '',
				bidLow: '',
			},
			analysis: {
				details: {
					type: 'Freehold',
					GLA: 7575,
					parking: 24,
					GRI: { eur: 4499820, gbp: 0 },
					wault: 13.2,
					vacancy: 0,
					valuation: { eur: 83996640 },
					GY: 5.25,
					NLA: { sqft: 0, sqm: 0 },
					oieo: 0,
				},
			},
		},
		{
			id: 'AFP SW051UK',
			index: 2, 
			coords: { lat: 53.519677, lng: 10.007637 },
			location: 'Schlinckstraße 1, 21107 Hamburg, Germany',
			description: [],
			processes: {
				nda: true,
				summary: false,
				loi: false,
				dd: false,
			},
			sell: {
				afp: 'SW051UK',
				digitalId: 20,
				country: 'Germany',
				city: 'Hamburg',
				address: 'Phoenix Hotel',
				assetType: 'Hotel',
				category: 'Core+',
				subClass: 'Single-tenant',
				status: 'Activate',
				loiDue: '20 March 2020, 17:00 GMT',
				loiDeposit: 'Valid',
				auctionDate: 'COB 30 March 2020',
			},
			tenants: [],
			status: {
				status: 'Inactive',
				dateLaunch: '',
				lastBid: '',
				ndas: '',
				teasers: '',
				ims: '',
				siteVisits: '',
				dataroom: '',
				lois: '',
				bidHigh: '',
				bidLow: '',
			},
			analysis: {
				details: {
					type: 'Freehold',
					GLA: 8540,
					parking: 25,
					GRI: { eur: 1332240, gbp: 0 },
					wault: 2.3,
					vacancy: 0,
					valuation: { eur: 21759920 },
					GY: 6,
					NLA: { sqft: 0, sqm: 0 },
					oieo: 0,
				},
			},
		},
	],
};

export default data;
